import React from "react";
import { Container } from "react-bootstrap";
import "./TermCondition.css";

const TermCondition = () => {
  return (
    <section className="terms-page">
      <Container>

        <h1 className="terms-title">
          TERMS AND CONDITIONS
        </h1>
        <p>
          Introductory Content 
          At Plenary Holidays, we believe in complete transparency. Our terms and conditions are designed to protect your interests and ensure a seamless travel experience. By booking with us, you benefit from 16 years of operational expertise and a commitment to ethical travel standards. Please review the general policies below, along with destination-specific annexures for your chosen program.
        </p>

        <h3 className="terms-subtitle">
          General Booking & Payment Policy (The Master Clause)
        </h3>

        <ul>
          <li>
            Confirmation: Bookings are confirmed only upon receipt of the initial deposit and a formal confirmation email from our corporate domain (@plenaryholidays.com).
          </li>
          <li>
            Payments: We accept NEFT, RTGS, IMPS, and Remittance. All payments must be GST-compliant.
          </li>
          <li>
            Price Volatility: For international travel, quotes are based on current Rate of Exchange (ROE). Final pricing is locked only upon 100% payment.
          </li>
        </ul>

        <h3 className="terms-subtitle">
          Section 2: Corporate & MICE Special Provisions
        </h3>

        <ul>
          <li>
            Contract Supremacy: For corporate events, the terms mentioned in the specific Signed Contract/MOU will supersede these general terms.
          </li>
          <li>
            Group Attrition: Cancellation of individual delegates within a MICE group is subject to the specific "Cut-off Dates" provided at the time of booking.
          </li>
          <li>
            Liability: Plenary Holidays acts as an aggregator between clients and vendors (Hotels/Airlines). While we ensure strict vendor due diligence, we are not liable for service deficiencies of third-party providers.
          </li>
        </ul>

        <h3 className="terms-subtitle">
          Section 3: Destination-Specific Annexures
        </h3>

        <ul>
          <li>Sikkim and West Bengal, All States (Download)</li>
        </ul>

        <h4 className="terms-subtitle">International</h4>

        <ul>
          <li>
            Visa Responsibility: While we provide assistance, the approval of a Visa is at the sole discretion of the respective Embassy.
          </li>
          <li>
            Hotel Check-in: Standard international check-in is 14:00 hrs and check-out is 12:00 hrs. Early check-ins are subject to availability and extra charges.
          </li>
        </ul>

        <p>
          Europe | Singapore | UAE-Dubai |Thailand | Malysia | Bali |Australia | CIS Countries | Bhutan | Nepal | Srilanka (Download Link)
        </p>

        <h3 className="terms-subtitle">
          Section 4: Cancellation, Amendment & Refund Policy
        </h3>

        <ul>
          <li>
            Written Notice: All cancellations must be submitted via email to your dedicated account manager.
          </li>
          <li>
            Refund Timeline: Approved refunds are processed within 15 working days after receiving payment from vendors
          </li>
          <li>
            Amendments: Minor changes (date shifts/name corrections) are subject to vendor availability and a nominal "Communication Fee."
          </li>
        </ul>

      </Container>
    </section>
  );
};

export default TermCondition;